// extracted by mini-css-extract-plugin
export default {"link":"styles_link__wWJjC","small":"styles_small__N1eH-","big":"styles_big__a04Jp","icon":"styles_icon__KnUyF","normal":"styles_normal__nfm8y","bold":"styles_bold__dyNxp"};